import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";
import { IJadaiDetails } from "../jadaiModel";

export const findAllJadai = createAsyncThunk(
  "Jadai/FindAllJadai",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Jadai/FindAllJadai`,
        formData,
      );
      // SuccessToast(response.data?.Details || "Success")
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetching Jadai", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createJadai = createAsyncThunk(
  "Jadai/InsertJadai",
  async (ghat: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Jadai/InsertJadai`,
        ghat,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Jadai:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateJadai = createAsyncThunk(
  "Jadai/UpdateJadai",
  async (ghat: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Jadai/UpdateJadai`,
        ghat,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Jadai:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteJadai = createAsyncThunk(
  "Jadai/DeleteJadai",
  async (ID: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Jadai/DeleteJadai`,
        { jadai_issue_guid: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Jadai:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getJadaiById = createAsyncThunk(
  "Jadai/FindByIDJadai",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Jadai/FindByIDJadai`,
        { jadai_issue_guid: ID },
      );
      const result = response.data?.Data as any;
      return {
        id: result.id,
        jadai_issue_guid: result.jadai_issue_guid,
        issue_no: result.issue_no,
        karigar_id: result.karigar_id,
        issue_date: result.issue_date ? moment(result.issue_date).toDate() : "",
        approx_delivery_date: result.approx_delivery_date
          ? moment(result.approx_delivery_date).toDate()
          : "",
        given_amount: result.given_amount,
        karigar_name: result.karigar_name,
        address: result.address,

        remarks: result.remarks,
        karigarIdWiseOutStandingAmount: result.karigarIdWiseOutStandingAmount,
        SizeDetails: result.SizeDetails,
        jadai_order: result.jadai_order
          ? result.jadai_order.map((gitem: any) => {
              return {
                id: gitem.id,
                jadai_issue_id: gitem.jadai_issue_id,
                delivery_date: gitem?.delivery_date || "",
                approx_delivery_date: gitem?.approx_delivery_date
                  ? moment(gitem.approx_delivery_date, "YYYY-MM-DD").toDate()
                  : "",
                order_no: gitem.order_no,
                process_id: gitem.process_id,
                order_id: gitem.order_id,
                item_id: gitem.item_id,
                item_name: gitem.item_name,
                item_category_id: gitem.item_category_id,
                item_subcategory_id: gitem.item_subcategory_id,
                category_name: gitem.category_name,
                item_subcategory_name: gitem.item_subcategory_name,
                Carat: gitem.Carat || "",
                PurityValue: gitem.PurityValue || "",
                purity_id: gitem.purity_id,
                weight: gitem.weight,
                remarks: gitem.remarks,
                image: gitem.image,
                size: gitem.size,
                color: gitem.color,
                priority: gitem.priority,
                ProcessImage: gitem.ProcessImage,
                purity: gitem.purity,
                KundanWeight: gitem.KundanWeight,
                jadaiprocessimage: gitem.jadaiprocessimage,
                approval_items: gitem.approval_items?.length
                  ? gitem.approval_items?.map((approvalItem: any) => {
                      return {
                        ...approvalItem,
                        IssueDate: approvalItem.IssueDate
                          ? moment(
                              approvalItem.IssueDate,
                              "YYYY-MM-DD",
                            ).toDate()
                          : null,
                      };
                    })
                  : [],
              };
            })
          : [],
        jadai_Entry_item: result.jadai_Entry_item
          ? result.jadai_Entry_item.map((results: any) => {
              return {
                id: results.id,
                IssueDate: results?.IssueDate
                  ? moment(results.IssueDate, "YYYY-MM-DD").toDate()
                  : null,
                jadai_issue_id: results.jadai_issue_id,
                item_id: results.item_id,
                item_name: results.item_name,
                given_weight: results.given_weight,
                given_purity: results.given_purity,
                given_wastage: results.given_wastage,
                phine: results.phine,
                pcs: results.pcs,
              };
            })
          : [],
      } as IJadaiDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Jadai:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteJadaiOrderItems = createAsyncThunk(
  "Jadai/DeleteJadaiOrder",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Jadai/DeleteJadaiOrder`,
        { id: ID },
      );
      SuccessToast(response?.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Jadai Order ITem:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const deleteJadaiEntryItems = createAsyncThunk(
  "Jadai/DeleteJadaiEntryItem",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Jadai/DeleteJadaiEntryItem`,
        { id: ID },
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Jadai Entry Item:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteJadaiApprovalItem = createAsyncThunk(
  "Jadai/DeleteJadaiApprovalItem",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Jadai/DeleteJadaiApprovalItem`,
        { id: ID },
      );
      SuccessToast(response?.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Jadai Approval Item:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
